import { render } from "./Sidebar.vue?vue&type=template&id=1e910188"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=1e910188&lang=css"
script.render = render

export default script